export function findExactSearchSuggestOption<T extends { value: string; label: string }>(
    options: T[],
    text: string,
): T | undefined {
    const query = text.trim().toLowerCase();
    if (!query) return undefined;
    return options.find(
        (option) => option.label.toLowerCase() === query || option.value.toLowerCase() === query,
    );
}
